<script setup lang="ts">
useHead({
  titleTemplate: (title) =>
      title ? `${title} - یاسان` : 'یاسان'
})
</script>

<template>
  <VApp>
    <VLocaleProvider :rtl="true">
      <VMain>
        <NuxtPage />
      </VMain>
    </VLocaleProvider>
  </VApp>
</template>
